import { authorizedApiClient } from "../config";

export interface ObjectFieldValuesRequest {
  workspace_id: string;
  object_type: string;
  field: string;
  search?: string;
  limit?: number;
}

export interface ObjectFieldDistinctValue {
  value: string;
  count: number;
}

export interface ObjectFieldValuesResponse {
  values: ObjectFieldDistinctValue[];
  total: number;
}

export const getObjectFieldValues = async (
  req: ObjectFieldValuesRequest,
): Promise<{ data: ObjectFieldValuesResponse }> =>
  authorizedApiClient.post(`/workspace/${req.workspace_id}/object-field-values`, {
    object_type: req.object_type,
    field: req.field,
    search: req.search,
    limit: req.limit,
  });
